import React from "react";
import { Space, Table } from "antd";
import Edit from "../../assets/icons/edit.svg";
import Delete from "../../assets/icons/delete.svg";

// Define the columns for the table
const columns = (openModal, deleteClick) => [
  {
    title: "Sr. No",
    key: "srNo",
    render: (_, __, index) => index + 1, // Render Sr. No based on the row index
  },
  {
    title: "Address",
    dataIndex: "businessAddress",
    key: "address",
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <img
          src={Edit}
          alt="Edit Icon"
          className="w-3 cursor-pointer"
          onClick={() => openModal(true, record)} // Trigger openModal on click
        />
        <img
          src={Delete}
          alt="Delete Icon"
          className="w-3 cursor-pointer"
          onClick={() => deleteClick(record)}
        />
      </Space>
    ),
  },
];

const LocationTable = ({ data, openModal, deleteClick }) => (
  <Table
    columns={columns(openModal, deleteClick)}
    dataSource={data}
    rowKey="key"
    pagination={false}
  />
);

export default LocationTable;
